// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_math = require("rescript/lib/js/js_math.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_unify = require("../worker/MM_wrk_unify.bs.js");
var MM_proof_tree = require("../mm-utils/MM_proof_tree.bs.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.bs.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var MM_proof_table = require("../mm-utils/MM_proof_table.bs.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var MM_substitution = require("../mm-utils/MM_substitution.bs.js");
var MM_cmp_user_stmt = require("./MM_cmp_user_stmt.bs.js");
var Expln_React_Modal = require("@expln/utils/src/main/react-components/Expln_React_Modal.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_utils_common = require("@expln/utils/src/main/Expln_utils_common.bs.js");
var MM_cmp_search_asrt = require("./MM_cmp_search_asrt.bs.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("@expln/utils/src/main/Expln_utils_promise.bs.js");
var MM_cmp_substitution = require("./MM_cmp_substitution.bs.js");
var Button = require("@mui/material/Button").default;
var Expln_utils_jsonParse = require("@expln/utils/src/main/Expln_utils_jsonParse.bs.js");
var MM_cmp_multiline_text = require("./MM_cmp_multiline_text.bs.js");
var Checkbox = require("@mui/material/Checkbox").default;
var Add = require("@mui/icons-material/Add").default;
var Hub = require("@mui/icons-material/Hub").default;
var IconButton = require("@mui/material/IconButton").default;
var Search = require("@mui/icons-material/Search").default;
var ArrowUpward = require("@mui/icons-material/ArrowUpward").default;
var ArrowDownward = require("@mui/icons-material/ArrowDownward").default;
var DeleteForever = require("@mui/icons-material/DeleteForever").default;
var Expln_React_ContentWithStickyHeader = require("@expln/utils/src/main/react-components/Expln_React_ContentWithStickyHeader.bs.js");
var TextRotationNone = require("@mui/icons-material/TextRotationNone").default;
var ControlPointDuplicate = require("@mui/icons-material/ControlPointDuplicate").default;

function userStmtLocStorToUserStmt(userStmtLocStor) {
  return {
          id: userStmtLocStor.id,
          label: userStmtLocStor.label,
          labelEditMode: false,
          typ: MM_wrk_editor.userStmtTypeFromStr(userStmtLocStor.typ),
          typEditMode: false,
          cont: MM_wrk_editor.strToCont(userStmtLocStor.cont),
          contEditMode: false,
          jstfText: userStmtLocStor.jstfText,
          jstfEditMode: false,
          stmtErr: undefined,
          expr: undefined,
          jstf: undefined,
          proof: undefined,
          proofStatus: undefined
        };
}

function createInitialEditorState(settingsV, settings, preCtxV, preCtx, stateLocStor) {
  return {
          settingsV: settingsV,
          settings: settings,
          preCtxV: preCtxV,
          preCtx: preCtx,
          frms: MM_substitution.prepareFrmSubsData(preCtx),
          varsText: Belt_Option.getWithDefault(Belt_Option.map(stateLocStor, (function (obj) {
                      return obj.varsText;
                    })), ""),
          varsEditMode: false,
          varsErr: undefined,
          disjText: Belt_Option.getWithDefault(Belt_Option.map(stateLocStor, (function (obj) {
                      return obj.disjText;
                    })), ""),
          disjEditMode: false,
          disjErr: undefined,
          disj: Belt_MapInt.fromArray([]),
          wrkCtx: undefined,
          nextStmtId: Belt_Option.getWithDefault(Belt_Option.map(stateLocStor, (function (obj) {
                      return obj.nextStmtId;
                    })), 0),
          stmts: Belt_Option.getWithDefault(Belt_Option.map(stateLocStor, (function (obj) {
                      return obj.stmts.map(userStmtLocStorToUserStmt);
                    })), []),
          checkedStmtIds: []
        };
}

function editorStateToEditorStateLocStor(state) {
  return {
          varsText: state.varsText,
          disjText: state.disjText,
          nextStmtId: state.nextStmtId,
          stmts: state.stmts.map(function (stmt) {
                return {
                        id: stmt.id,
                        label: stmt.label,
                        typ: stmt.typ,
                        cont: MM_wrk_editor.contToStr(stmt.cont),
                        jstfText: stmt.jstfText
                      };
              })
        };
}

function editorSaveStateToLocStor(state, key) {
  localStorage.setItem(key, Expln_utils_common.stringify(editorStateToEditorStateLocStor(state)));
}

function readEditorStateFromLocStor(key) {
  var stateLocStorStr = localStorage.getItem(key);
  if (stateLocStorStr === null) {
    return ;
  }
  var parseResult = Expln_utils_jsonParse.parseObj(stateLocStorStr, (function (d) {
          return {
                  varsText: Belt_Option.getWithDefault(Expln_utils_jsonParse.strOpt(d, "varsText"), ""),
                  disjText: Belt_Option.getWithDefault(Expln_utils_jsonParse.strOpt(d, "disjText"), ""),
                  nextStmtId: Expln_utils_jsonParse.$$int(d, "nextStmtId"),
                  stmts: Expln_utils_jsonParse.arr(d, "stmts", (function (d) {
                          return {
                                  id: Expln_utils_jsonParse.str(d, "id"),
                                  label: Expln_utils_jsonParse.str(d, "label"),
                                  typ: Expln_utils_jsonParse.str(d, "typ"),
                                  cont: Expln_utils_jsonParse.str(d, "cont"),
                                  jstfText: Expln_utils_jsonParse.str(d, "jstfText")
                                };
                        }))
                };
        }));
  if (parseResult.TAG === /* Ok */0) {
    return parseResult._0;
  }
  
}

function rndIconButton(icon, onClick, active, title, param) {
  var tmp = {};
  if (title !== undefined) {
    tmp.title = Caml_option.valFromOption(title);
  }
  return React.createElement("span", tmp, React.createElement(IconButton, {
                  onClick: (function (param) {
                      Curry._1(onClick, undefined);
                    }),
                  color: "primary",
                  disabled: !active,
                  children: icon
                }));
}

var stateLocStorKey = "editor-state";

var lastUsedAsrtSearchTypLocStorKey = "search-asrt-typ";

function saveLastUsedTyp(ctx, typInt) {
  var typStr = MM_context.ctxIntToSym(ctx, typInt);
  if (typStr !== undefined) {
    localStorage.setItem(lastUsedAsrtSearchTypLocStorKey, typStr);
    return ;
  }
  
}

function getLastUsedTyp(ctx) {
  var typStr = localStorage.getItem(lastUsedAsrtSearchTypLocStorKey);
  if (typStr !== null) {
    return MM_context.ctxSymToInt(ctx, typStr);
  }
  
}

function MM_cmp_editor(Props) {
  var modalRef = Props.modalRef;
  var settingsV = Props.settingsV;
  var settings = Props.settings;
  var preCtxV = Props.preCtxV;
  var preCtx = Props.preCtx;
  var top = Props.top;
  var match = React.useState(function () {
        return createInitialEditorState(settingsV, settings, preCtxV, preCtx, readEditorStateFromLocStor(stateLocStorKey));
      });
  var setStatePriv = match[1];
  var state = match[0];
  var setState = function (update) {
    Curry._1(setStatePriv, (function (st) {
            var st$1 = Curry._1(update, st);
            var st$2 = MM_wrk_editor.prepareEditorForUnification(st$1);
            var st$3 = Belt_Option.isSome(st$2.wrkCtx) ? MM_wrk_editor.removeUnusedVars(st$2) : st$2;
            editorSaveStateToLocStor(st$3, stateLocStorKey);
            return st$3;
          }));
  };
  var actSettingsUpdated = function (settingsV, settings) {
    setState(function (__x) {
          return MM_wrk_editor.setSettings(__x, settingsV, settings);
        });
  };
  React.useEffect((function () {
          actSettingsUpdated(settingsV, settings);
        }), [settingsV]);
  var actPreCtxUpdated = function (preCtxV, preCtx) {
    setState(function (__x) {
          return MM_wrk_editor.setPreCtx(__x, preCtxV, preCtx);
        });
  };
  React.useEffect((function () {
          actPreCtxUpdated(preCtxV, preCtx);
        }), [preCtxV]);
  var thereAreSyntaxErrors = MM_wrk_editor.editorStateHasErrors(state);
  var atLeastOneStmtIsChecked = state.checkedStmtIds.length !== 0;
  var atLeastOneStmtIsNotChecked = state.stmts.length !== state.checkedStmtIds.length;
  var mainCheckboxState = atLeastOneStmtIsChecked && atLeastOneStmtIsNotChecked ? undefined : (
      atLeastOneStmtIsChecked && !atLeastOneStmtIsNotChecked ? true : false
    );
  var editIsActive = state.varsEditMode || state.disjEditMode || state.stmts.some(function (stmt) {
        if (stmt.labelEditMode || stmt.typEditMode || stmt.contEditMode) {
          return true;
        } else {
          return stmt.jstfEditMode;
        }
      });
  var actAddNewStmt = function (param) {
    setState(function (st) {
          return MM_wrk_editor.addNewStmt(st)[0];
        });
  };
  var actDeleteCheckedStmts = function (param) {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return React.createElement(Paper, {
                                style: {
                                  padding: "10px"
                                },
                                children: React.createElement(Expln_React_Column.make, {
                                      spacing: 1,
                                      children: null
                                    }, "Delete selected statements?", React.createElement(Expln_React_Row.make, {
                                          children: null
                                        }, React.createElement(Button, {
                                              onClick: (function (param) {
                                                  Expln_React_Modal.closeModal(modalRef, modalId);
                                                }),
                                              children: "Cancel"
                                            }), React.createElement(Button, {
                                              onClick: (function (param) {
                                                  Expln_React_Modal.closeModal(modalRef, modalId);
                                                  setState(MM_wrk_editor.deleteCheckedStmts);
                                                }),
                                              variant: "contained",
                                              children: "Delete"
                                            })))
                              });
                  }));
          }));
  };
  var actMoveCheckedStmtsUp = function (param) {
    setState(function (__x) {
          return MM_wrk_editor.moveCheckedStmts(__x, true);
        });
  };
  var actMoveCheckedStmtsDown = function (param) {
    setState(function (__x) {
          return MM_wrk_editor.moveCheckedStmts(__x, false);
        });
  };
  var actDuplicateStmt = function (param) {
    setState(function (st) {
          return MM_wrk_editor.uncheckAllStmts(MM_wrk_editor.duplicateCheckedStmt(st));
        });
  };
  var actBeginEdit0 = function (setter) {
    if (!editIsActive) {
      return setState(setter);
    }
    
  };
  var actBeginEdit = function (setter, stmtId) {
    if (!editIsActive) {
      return setState(function (__x) {
                  return Curry._2(setter, __x, stmtId);
                });
    }
    
  };
  var actSearchAsrt = function (param) {
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return ;
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return React.createElement(MM_cmp_search_asrt.make, {
                                modalRef: modalRef,
                                preCtxVer: state.preCtxV,
                                preCtx: state.preCtx,
                                parenStr: state.settings.parens,
                                varsText: state.varsText,
                                disjText: state.disjText,
                                hyps: state.stmts.filter(function (stmt) {
                                        return stmt.typ === "e";
                                      }).map(function (stmt) {
                                      return {
                                              id: stmt.id,
                                              label: stmt.label,
                                              text: MM_wrk_editor.contToStr(stmt.cont)
                                            };
                                    }),
                                wrkCtx: wrkCtx$1,
                                frms: state.frms,
                                initialTyp: getLastUsedTyp(state.preCtx),
                                onTypChange: (function (__x) {
                                    saveLastUsedTyp(state.preCtx, __x);
                                  }),
                                onCanceled: (function (param) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                onResultsSelected: (function (selectedResults) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                    setState(function (st) {
                                          return selectedResults.reduce(MM_wrk_editor.addAsrtSearchResult, st);
                                        });
                                  })
                              });
                  }));
          }));
  };
  var actSubstitute = function (param) {
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return ;
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return React.createElement(MM_cmp_substitution.make, {
                                editorState: state,
                                wrkCtx: wrkCtx$1,
                                onCanceled: (function (param) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                onSubstitutionSelected: (function (wrkSubs) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                    setState(function (st) {
                                          return MM_wrk_editor.applySubstitutionForEditor(st, wrkSubs);
                                        });
                                  })
                              });
                  }));
          }));
  };
  var actUnifyAll = function (param) {
    var match = state.wrkCtx;
    if (match !== undefined) {
      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                  return MM_react_common.rndProgress("Unifying", 0);
                })), (function (modalId) {
              return Expln_utils_promise.promiseMap(MM_wrk_unify.unify(state.preCtxV, state.preCtx, state.settings.parens, state.varsText, state.disjText, state.stmts.filter(function (stmt) {
                                    return stmt.typ === "e";
                                  }).map(function (stmt) {
                                  return {
                                          id: stmt.id,
                                          label: stmt.label,
                                          text: MM_wrk_editor.contToStr(stmt.cont)
                                        };
                                }), state.stmts.filter(function (stmt) {
                                    return stmt.typ === "p";
                                  }).map(function (stmt) {
                                  var expr = stmt.expr;
                                  var tmp;
                                  if (expr !== undefined) {
                                    tmp = expr;
                                  } else {
                                    throw {
                                          RE_EXN_ID: MM_parser.MmException,
                                          _1: {
                                            msg: "Expr must be set for all statements before unification."
                                          },
                                          Error: new Error()
                                        };
                                  }
                                  return {
                                          label: stmt.label,
                                          expr: tmp,
                                          justification: stmt.jstf
                                        };
                                }), (function (pct) {
                                Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                        return MM_react_common.rndProgress("Unifying", pct);
                                      }));
                              })), (function (proofTreeDto) {
                            Expln_React_Modal.closeModal(modalRef, modalId);
                            Curry._1(setStatePriv, (function (st) {
                                    var st$1 = MM_wrk_editor.applyUnifyAllResults(st, proofTreeDto);
                                    editorSaveStateToLocStor(st$1, stateLocStorKey);
                                    return st$1;
                                  }));
                          }));
            }));
      return ;
    }
    
  };
  var splitIntoChunks = function (str, chunkMaxSize) {
    var len = str.length;
    if (len <= chunkMaxSize) {
      return [str];
    }
    var res = [];
    var numberOfChunks = Js_math.ceil_int(len / chunkMaxSize);
    for(var i = 1; i <= numberOfChunks; ++i){
      var begin = Math.imul(i - 1 | 0, chunkMaxSize);
      res.push(str.substr(begin, chunkMaxSize));
    }
    return res;
  };
  var proofToText = function (ctx, stmt, proof) {
    if (proof.TAG === /* Uncompressed */0) {
      return "Error: only compressed proofs are supported.";
    }
    var blk = splitIntoChunks(proof.compressedProofBlock, 50).join(" ");
    var asrt = "" + stmt.label + " $p " + MM_wrk_editor.contToStr(stmt.cont) + " $= ( " + proof.labels.join(" ") + " ) " + blk + " $.";
    var localVars = MM_context.getLocalVars(ctx);
    var localDisj = MM_context.getLocalDisj(ctx);
    var localHyps = MM_context.getLocalHyps(ctx);
    var blockIsRequired = localHyps.length > 0 || !MM_context.disjIsEmpty(localDisj);
    var result = [];
    if (blockIsRequired) {
      result.push("${");
    }
    if (localVars.length > 0) {
      result.push("$v " + localVars.join(" ") + " $.");
    }
    MM_context.disjForEachArr(localDisj, (function (vars) {
            result.push("$d " + MM_context.ctxIntsToStrExn(ctx, vars) + " $.");
          }));
    localHyps.forEach(function (hyp) {
          var hypTypStr = hyp.typ === /* F */0 ? " $f " : " $e ";
          result.push(hyp.label + hypTypStr + MM_context.ctxIntsToStrExn(ctx, hyp.expr) + " $.");
        });
    result.push(asrt);
    if (blockIsRequired) {
      result.push("$}");
    }
    return result.join("\r\n");
  };
  var rndError = function (msgOpt) {
    if (msgOpt !== undefined) {
      return React.createElement("pre", {
                  style: {
                    color: "red"
                  }
                }, msgOpt);
    } else {
      return null;
    }
  };
  var rndButtons = function (param) {
    var generalModificationActionIsEnabled = !editIsActive && !thereAreSyntaxErrors;
    var atLeastOneStmtIsSelected = Belt_Option.getWithDefault(mainCheckboxState, true);
    return React.createElement(Paper, {
                children: React.createElement(Expln_React_Row.make, {
                      children: null
                    }, React.createElement(Checkbox, {
                          disabled: editIsActive,
                          indeterminate: Belt_Option.isNone(mainCheckboxState),
                          checked: Belt_Option.getWithDefault(mainCheckboxState, false),
                          onChange: (function (param) {
                              var action = mainCheckboxState !== undefined && !mainCheckboxState ? MM_wrk_editor.checkAllStmts : MM_wrk_editor.uncheckAllStmts;
                              Curry._1(setStatePriv, (function (st) {
                                      var st$1 = Curry._1(action, st);
                                      editorSaveStateToLocStor(st$1, stateLocStorKey);
                                      return st$1;
                                    }));
                            })
                        }), rndIconButton(React.createElement(ArrowDownward, {}), actMoveCheckedStmtsDown, !editIsActive && MM_wrk_editor.canMoveCheckedStmts(state, false), "Move selected statements down", undefined), rndIconButton(React.createElement(ArrowUpward, {}), actMoveCheckedStmtsUp, !editIsActive && MM_wrk_editor.canMoveCheckedStmts(state, true), "Move selected statements up", undefined), rndIconButton(React.createElement(Add, {}), actAddNewStmt, !editIsActive, "Add new statement (and place before selected statements if any)", undefined), rndIconButton(React.createElement(DeleteForever, {}), actDeleteCheckedStmts, !editIsActive && atLeastOneStmtIsSelected, "Delete selected statements", undefined), rndIconButton(React.createElement(ControlPointDuplicate, {}), actDuplicateStmt, !editIsActive && MM_wrk_editor.isSingleStmtChecked(state), "Duplicate selected statement", undefined), rndIconButton(React.createElement(Search, {}), actSearchAsrt, generalModificationActionIsEnabled && Belt_MapString.size(state.frms) > 0, "Add new statements from existing assertions (and place before selected statements if any)", undefined), rndIconButton(React.createElement(TextRotationNone, {}), actSubstitute, generalModificationActionIsEnabled, "Apply a substitution to all statements", undefined), rndIconButton(React.createElement(Hub, {}), actUnifyAll, generalModificationActionIsEnabled && !atLeastOneStmtIsSelected && state.stmts.length > 0, "Unify all statements", undefined))
              });
  };
  var rndStmt = function (stmt) {
    return React.createElement("tr", {
                key: stmt.id
              }, React.createElement("td", {
                    style: {
                      verticalAlign: "top"
                    }
                  }, React.createElement(Checkbox, {
                        disabled: editIsActive,
                        checked: MM_wrk_editor.isStmtChecked(state, stmt.id),
                        onChange: (function (param) {
                            var id = stmt.id;
                            Curry._1(setStatePriv, (function (st) {
                                    var st$1 = MM_wrk_editor.toggleStmtChecked(st, id);
                                    editorSaveStateToLocStor(st$1, stateLocStorKey);
                                    return st$1;
                                  }));
                          })
                      })), React.createElement("td", undefined, React.createElement(MM_cmp_user_stmt.make, {
                        stmt: stmt,
                        onLabelEditRequested: (function (param) {
                            actBeginEdit(MM_wrk_editor.setLabelEditMode, stmt.id);
                          }),
                        onLabelEditDone: (function (newLabel) {
                            setState(function (__x) {
                                  return MM_wrk_editor.completeLabelEditMode(__x, stmt.id, newLabel);
                                });
                          }),
                        onTypEditRequested: (function (param) {
                            actBeginEdit(MM_wrk_editor.setTypEditMode, stmt.id);
                          }),
                        onTypEditDone: (function (newTyp) {
                            setState(function (__x) {
                                  return MM_wrk_editor.completeTypEditMode(__x, stmt.id, newTyp);
                                });
                          }),
                        onContEditRequested: (function (param) {
                            actBeginEdit(MM_wrk_editor.setContEditMode, stmt.id);
                          }),
                        onContEditDone: (function (newCont) {
                            setState(function (__x) {
                                  return MM_wrk_editor.completeContEditMode(__x, stmt.id, newCont);
                                });
                          }),
                        onJstfEditRequested: (function (param) {
                            actBeginEdit(MM_wrk_editor.setJstfEditMode, stmt.id);
                          }),
                        onJstfEditDone: (function (newJstf) {
                            setState(function (__x) {
                                  return MM_wrk_editor.completeJstfEditMode(__x, stmt.id, newJstf);
                                });
                          }),
                        onGenerateProof: (function (param) {
                            var stmtId = stmt.id;
                            var wrkCtx = state.wrkCtx;
                            if (wrkCtx === undefined) {
                              return ;
                            }
                            var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
                            var stmt$1 = state.stmts.find(function (stmt) {
                                  return stmt.id === stmtId;
                                });
                            if (stmt$1 === undefined) {
                              return ;
                            }
                            var proofNode = stmt$1.proof;
                            if (proofNode === undefined) {
                              return ;
                            }
                            var proofTable = MM_proof_tree.proofTreeCreateProofTable(proofNode);
                            MM_proof_table.proofTablePrint(wrkCtx$1, proofTable, "exported-proof");
                            var proof = MM_proof_table.createProof(wrkCtx$1, proofTable, proofTable.length - 1 | 0);
                            Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                        return null;
                                      })), (function (modalId) {
                                    Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                            var proofStr = proofToText(wrkCtx$1, stmt$1, proof);
                                            return React.createElement(Paper, {
                                                        style: {
                                                          padding: "10px"
                                                        },
                                                        children: React.createElement(Expln_React_Column.make, {
                                                              children: null
                                                            }, React.createElement("pre", {
                                                                  style: {
                                                                    whiteSpace: "pre-wrap",
                                                                    overflowWrap: "break-word"
                                                                  }
                                                                }, proofStr), React.createElement(Button, {
                                                                  onClick: (function (param) {
                                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                                    }),
                                                                  children: "Close"
                                                                }))
                                                      });
                                          }));
                                  }));
                          })
                      }), rndError(stmt.stmtErr)));
  };
  var rndVars = function (param) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "7px",
                  marginLeft: "7px"
                },
                children: null
              }, "Variables", React.createElement(Expln_React_Column.make, {
                    children: null
                  }, React.createElement(MM_cmp_multiline_text.make, {
                        text: state.varsText,
                        editMode: state.varsEditMode,
                        onEditRequested: (function (param) {
                            actBeginEdit0(MM_wrk_editor.setVarsEditMode);
                          }),
                        onEditDone: (function (newText) {
                            setState(function (__x) {
                                  return MM_wrk_editor.completeVarsEditMode(__x, newText);
                                });
                          })
                      }), rndError(state.varsErr)));
  };
  var rndDisj = function (param) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "7px",
                  marginLeft: "7px"
                },
                children: null
              }, "Disjoints", React.createElement(Expln_React_Column.make, {
                    children: null
                  }, React.createElement(MM_cmp_multiline_text.make, {
                        text: state.disjText,
                        editMode: state.disjEditMode,
                        onEditRequested: (function (param) {
                            actBeginEdit0(MM_wrk_editor.setDisjEditMode);
                          }),
                        onEditDone: (function (newText) {
                            setState(function (__x) {
                                  return MM_wrk_editor.completeDisjEditMode(__x, newText);
                                });
                          })
                      }), rndError(state.disjErr)));
  };
  var rndStmts = function (param) {
    return React.createElement("table", undefined, React.createElement("tbody", undefined, state.stmts.map(rndStmt)));
  };
  return React.createElement(Expln_React_ContentWithStickyHeader.make, {
              top: top,
              header: rndButtons(undefined),
              content: (function (param) {
                  return React.createElement(Expln_React_Column.make, {
                              children: null
                            }, rndVars(undefined), rndDisj(undefined), rndStmts(undefined));
                })
            });
}

var make = MM_cmp_editor;

exports.userStmtLocStorToUserStmt = userStmtLocStorToUserStmt;
exports.createInitialEditorState = createInitialEditorState;
exports.editorStateToEditorStateLocStor = editorStateToEditorStateLocStor;
exports.editorSaveStateToLocStor = editorSaveStateToLocStor;
exports.readEditorStateFromLocStor = readEditorStateFromLocStor;
exports.rndIconButton = rndIconButton;
exports.stateLocStorKey = stateLocStorKey;
exports.lastUsedAsrtSearchTypLocStorKey = lastUsedAsrtSearchTypLocStorKey;
exports.saveLastUsedTyp = saveLastUsedTyp;
exports.getLastUsedTyp = getLastUsedTyp;
exports.make = make;
/* react Not a pure module */
